import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { PhBhpFilterComponent } from '../ph-bhp-filter/ph-bhp-filter.component';
import { PhBhpConsumptionFilterComponent } from '../ph-bhp-consumption-filter/ph-bhp-consumption-filter.component';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageEvaluationService } from '../ph-bhp-feature-package-evaluation.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { formatDate } from '@angular/common';

@Component({
  selector: 'lib-ph-bhp-pdf-compliance',
  templateUrl: './ph-bhp-pdf-compliance.component.html',
  styleUrls: ['./ph-bhp-pdf-compliance.component.css']
})
export class PhBhpPdfComplianceComponent implements OnInit {
  public repeatHeaders = true;
  @ViewChild('chart') chart;
  @ViewChild('filterDetails') filterDetails;
  // @ViewChild('chart1') chart1;
  @ViewChildren('chartList') chartList
  @ViewChild('pdf') pdf;
  childChartCount: Array<any> = [];
  show1 = false;
  printChart = false;
  roleId;
  range1 = {
    start: new Date(),
    end: new Date()
  }
  maxDate = new Date()
  minDate: Date = void 0;
  showCompareCard = false;
  showFilter = false;
  @ViewChild('filter') filter: PhBhpFilterComponent;
  @ViewChild('filter2') filter2: PhBhpFilterComponent;
  @ViewChild('filter3') filter3: PhBhpConsumptionFilterComponent;
  @ViewChild('filter4') filter4: PhBhpConsumptionFilterComponent;
  complianceTitle;
  subStepDetail : boolean;
  isObserve : boolean =  false;
  SOPName;
  Steps;
  specificStep;
  setCountry: any = 0;
  setInstitution: any = 0;
  setWard: any = 0;
  setDepartment: any = 0;
  setCategory: any = 0;
  setSubCategory: any = 0;
  dateRange: Date[];
  setCountry2: any = 0;
  setInstitution2: any = 0;
  setWard2: any = 0;
  setDepartment2: any = 0;
  setCategory2: any = 0;
  setSubCategory2: any = 0;
  dateRange2: Date[];
  setCountry3: any = 0;
  setInstitution3: any = 0;
  setWard3: any = 0;
  setDepartment3: any = 0;
  setCategory3: any = 0;
  setSubCategory3: any = 0;
  dateRange3: Date[];
  setCountry4: any = 0;
  setInstitution4: any = 0;
  setWard4: any = 0;
  setDepartment4: any = 0;
  setCategory4: any = 0;
  setSubCategory4: any = 0;
  dateRange4: Date[];
  SOPList: Array<any>;
  gridData: Array<any>;
  fields: Array<any>;
  secGridData: Array<any>;
  secFields: Array<any>;
  font = "8px OpenSans-Regular"
  logoSrc = 'assets/img/app-logo.svg';
  constructor(
    public config: AppConfig,
    private service: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService
    ) { }

  showProfessionalSubcategory:boolean = false;

  ngOnInit() {
    this.loadLogo();
  }

  ngAfterViewInit() {
    if(this.config.institutions){
      var institutions = this.config.institutions.split(',');
      institutions.forEach(inst => {
        this.service.getConfigDetails(inst).subscribe((res) => {
          if(res.enableProfessionalSubCategory){
            this.showProfessionalSubcategory = true;
          }
        });
      });
    }

    this.chartList.changes.subscribe((newList) => {
      newList.forEach((list, index) => {
        list.font = this.font;
        list.chartOptions = this.childChartCount[index].chartOptions
        list.chartOptions.categoryAxis.categories = this.childChartCount[index].categories
        list.chartOptions.series = this.childChartCount[index].series;
        list.chartOptions.valueAxis.title.font = this.font;
        list.chartOptions.legend.font = this.font;
        list.chartOptions.legend.labels = { font: this.font };
        list.chartDatamani();
        var recodeLength = this.childChartCount[index].categories.length
        if(recodeLength > 8){
          list.chart.element.nativeElement.style.height = "700px"
        } else if (recodeLength > 5){
          list.chart.element.nativeElement.style.height = "550px"
        } else {
          list.chart.element.nativeElement.style.height = "400px"
        }

      })
    });
  }

  setFilterOne(filter: PhBhpFilterComponent) {
    this.setCountry = filter.setCountry;
    this.setInstitution = filter.setInstitution;
    this.setWard = filter.setWard;
    this.setDepartment = filter.setDepartment;
    this.setCategory = filter.setCategory;
    this.setSubCategory = filter.setSubCategory;
    this.dateRange = [filter.range1.start, filter.range1.end];
    this.formatDateRange('dateRange');
  }

  setFilterTwo(filter: PhBhpFilterComponent) {
    this.setCountry2 = filter.setCountry;
    this.setInstitution2 = filter.setInstitution;
    this.setWard2 = filter.setWard;
    this.setDepartment2 = filter.setDepartment;
    this.setCategory2 = filter.setCategory;
    this.setSubCategory2 = filter.setSubCategory;
    this.dateRange2 = [filter.range1.start, filter.range1.end];
    this.formatDateRange('dateRange2');
  }

  setFilterThree(filter: PhBhpConsumptionFilterComponent) {
    this.setCountry3 = filter.setCountry;
    this.setInstitution3 = filter.setInstitution;
    this.setWard3= filter.setWard;
    this.setDepartment3 = filter.setDepartment;
    this.dateRange3 = [filter.range1.start, filter.range1.end];
    this.formatDateRange('dateRange3');
  }

  setFilterFour(filter: PhBhpConsumptionFilterComponent) {
    this.setCountry4 = filter.setCountry;
    this.setInstitution4 = filter.setInstitution;
    this.setWard4 = filter.setWard;
    this.setDepartment4 = filter.setDepartment;
    this.dateRange4 = [filter.range1.start, filter.range1.end];
    this.formatDateRange('dateRange4');
  }

  breakChart() {
    this.chart.chartOptions.valueAxis.title.font = this.font;
    this.chart.font = this.font;
    var chartOptions = JSON.parse(JSON.stringify(this.chart.chartOptions));
    var offsetHeight =  this.filterDetails.nativeElement.offsetHeight
    var ChartHight = 700 - (offsetHeight+50);

    if(ChartHight>=550){
      var barLenth = 10
    } else if(ChartHight>=400) {
      var barLenth = 8
    } else {
      var barLenth = 5
    }
    if( this.showCompareCard ){
      barLenth = barLenth - 2;
    }
    this.childChartCount = [];
    this.chart.chart.element.nativeElement.style.height = ChartHight+"px"
    if (chartOptions.series[0].data.length > barLenth) {
       var categoryAxis = chartOptions.categoryAxis.categories;
      var newCategoryAxis = categoryAxis.splice(0, barLenth);
      this.chart.chartOptions.categoryAxis.categories = newCategoryAxis;
      chartOptions.series.forEach((element, index) => {
        var newArray = element.data.splice(0, barLenth);
        this.chart.chartOptions.series[index].data = newArray;
      });
      while (chartOptions.series[0].data.length) {
        if (chartOptions.series[0].data.length > 10) {
          var tempData = chartOptions.series;
          var categoryAxis = chartOptions.categoryAxis.categories;
          var newCategoryAxis = categoryAxis.splice(0, 10);
          chartOptions.series.forEach((element, index) => {
            var newArray = element.data.splice(0, 10);
            tempData[index].data = newArray;
          });
          this.childChartCount.push({
            chartOptions: chartOptions,
            categories: newCategoryAxis,
            series: tempData
          })
        } else {
          this.childChartCount.push({
            chartOptions: chartOptions,
            categories: chartOptions.categoryAxis.categories,
            series: chartOptions.series
          })
          break;
        }
      }
    }

    this.chart.chartOptions.valueAxis.title.font = this.font;
    this.chart.chartOptions.legend.font = this.font;
    this.chart.chartOptions.legend.labels = { font: this.font };

    this.childChartCount.forEach((element) => {
      element.chartOptions.valueAxis.title.font = this.font;
      element.chartOptions.legend.font = this.font;
      element.chartOptions.legend.labels = { font: this.font };
    });
  }

  formatDateRange(dateRangeProperty: string) {
    const format = 'dd/MM/yyyy';
    const locale = 'en-GB';
    const startDate = this[dateRangeProperty][0];
    const endDate = this[dateRangeProperty][1];

    const formattedStartDate = formatDate(startDate, format, locale);
    const formattedEndDate = formatDate(endDate, format, locale);

    this[dateRangeProperty + 'Formatted'] = `${formattedStartDate} - ${formattedEndDate}`;
  }

  private loadLogo(): void {
    this.layoutService.getAppLogoBase64()
      .then((logo) => {
        if (!logo) {
          return;
        }

        this.logoSrc = logo;
      })
      .catch(() => {
        // Keep default asset path fallback if conversion fails        // Keep default asset path fallback if conversion fails
        this.logoSrc = 'assets/img/app-logo.svg';
      });
  }
}
